"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemSelect = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Button = require("../../../UI/Button");
var _useIframe2 = require("../hooks/useIframe");
var _jsxRuntime = require("react/jsx-runtime");
var ItemSelect = function ItemSelect(props) {
  var itemID = props.itemID,
    taskID = props.taskID,
    itemLanguage = props.itemLanguage,
    itemSpace = props.itemSpace,
    kotarParams = props.kotarParams,
    minDate = props.minDate,
    maxDate = props.maxDate;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    unitData = _useContext.unitData,
    getLabel = _useContext.getLabel;
  var _useIframe = (0, _useIframe2.useIframe)(itemID, itemLanguage, taskID, kotarParams, minDate, maxDate),
    setIframeData = _useIframe.setIframeData;
  var handleSelectItemBtnClick = function handleSelectItemBtnClick() {
    setIframeData({
      title: getLabel('select_item_popup_title'),
      src: unitData && unitData.taskFormUrls && unitData.taskFormUrls.itemSelectionUrl ? unitData.taskFormUrls.itemSelectionUrl.replace('http:', '').replace('{0}', itemSpace || '') : ''
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('main_title')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: getLabel('item_select_text')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "outlined",
          onClick: handleSelectItemBtnClick,
          children: getLabel('select_item_btn')
        })
      })
    })]
  });
};
exports.ItemSelect = ItemSelect;